import {useCallback} from 'react'
import {useSelector} from 'react-redux'

function useResidentOrChatParticipantLookup() {
  const residentsLookup = useSelector(state => state.Residents.residentsLookup)

  const chatParticipantsLookup = useSelector(state => state.ChatParticipants.chatParticipantsLookup)

  /**
   * @param {string} residentId
   * @return {RichResidentObject}
   */
  const getResidentOrChatParticipant = useCallback(residentOrChatParticipantId => {
    const resident = residentsLookup[residentOrChatParticipantId]

    const chatParticipant = chatParticipantsLookup[residentOrChatParticipantId]

    if (resident) {
      return resident
    }

    if (chatParticipant) {
      const residentId = chatParticipant.participantId
      const resident = residentsLookup[residentId]

      return resident
    }

    return {
      displayName: '',
      occupancy: {
        unit: {
          unitBuildingId: '',
          number: '',
        },
      },
    }
  }, [residentsLookup, chatParticipantsLookup])

  return {
    getResidentOrChatParticipant,
  }
}

export default useResidentOrChatParticipantLookup
